import { toast } from "@/components/UIComponents/Toast";
import { getErrorMessage } from "@/services/errors/errorHandler";

export const success = (message: string) => toast.success(message);
export const error = (message: string) => toast.error(message);
export const warning = (message: string) => toast.warning(message);

export const handleApiError = (err: unknown, fallback: string) =>
  error(getErrorMessage(err, fallback));
